import {ICoach, UserStatusEnum} from "@/interfaces/interface";
import {ImageFromAssets} from "@/shared";
import {RequestBodyApproved} from "./RequestBodyApproved/RequestBodyApproved";
import {RequestBodyAutoApproved} from "./RequestBodyAutoApproved/RequestBodyAutoApproved";
import {RequestBodyDeclined} from "./RequestBodyDeclined/RequestBodyDeclined";
import {RequestBodyNew} from "./RequestBodyNew/RequestBodyNew";
import "./RequestsBody.scss";

type Props = {
  activeStatus: UserStatusEnum;
  coachesByStatus: ICoach[];
};

export function RequestBody({activeStatus, coachesByStatus}: Props) {
  const bodyByStatus: Record<
    UserStatusEnum,
    | typeof RequestBodyApproved
    | typeof RequestBodyNew
    | typeof RequestBodyDeclined
    | typeof RequestBodyAutoApproved
  > = {
    [UserStatusEnum.APPROVED]: RequestBodyApproved,
    [UserStatusEnum.DECLINED]: RequestBodyDeclined,
    [UserStatusEnum.PENDING]: RequestBodyNew,
    [UserStatusEnum.AUTO_APPROVED]: RequestBodyAutoApproved,
  };

  const Body = bodyByStatus[activeStatus];

  if (Boolean(!coachesByStatus.length)) {
    return (
      <div className="empty-users">
        <ImageFromAssets
          className="empty-users__image"
          name="empty-users.webp"
        />
      </div>
    );
  }

  return <Body coachesByStatus={coachesByStatus}/>;
}
